<template>
    <div>
        <nav-bar-main></nav-bar-main> 
                
        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>
        
        <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div>

        <Loader />
        <div v-if="plantDetails != null && zoneDetails !=null" class="animated fadeIn container-fluid">
            
            <!-- Tabella zones -->
            <div v-if="tableData" style="margin-top:10px">
           
            <b-row class="mt-4 justify-content-center">
                <b-col v-for="item in tableData" v-bind:key="item.zoneId"  xl="4" lg="6" md="12" class="mt-4">
            <b-card border-variant="primary" body-class="nopad">

                <div slot="header">
                    {{item.zoneName}}
                    <div class="card-header-actions">
                        <b-link href="#" class="card-header-action btn-close" @click="paginaDettaglioZona(item)" >
                            <i class="fa fa-trash"></i>
                        </b-link>
                    </div>
                </div>

                <b-card
                overlay
                :id="'imgDiv'+item.zoneId"
                img-src="/img/empty_map.jpg" fluid @click="paginaDettaglioZona(item)"
                ></b-card>
                 
            </b-card>

        </b-col>
        <b-col>
            <b-button v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" @click="showModalDisclaimer()" ><span style="font-size:40px; font-weight: bold">+</span><br/>{{this.$t("zone.add_zone")}}</b-button>
        </b-col>
            </b-row>

            </div>

        </div>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'
import NavBarZone from '@/components/NavBarZone'
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';
//import DragItDude from 'vue-drag-it-dude';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import panZoom from 'vue-panzoom'
Vue.use(panZoom);

import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;



import { mapState } from 'vuex';

export default {
    name: 'Zone',
    components: {
        NavBarMain,
        NavBarZone,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoENG,
        DisclaimerPhotoITA,
        DisclaimerPhotoGER,
        vueDropzone: vue2Dropzone,
        jsPDF,
        JsPDFAutotable,
        hideAt, 
        showAt,
    },
    props: ['plantId'],
    data() {
        return {
            highlightedLamp: "",
            filtro: "",
            tabIndex: 0,
            lampToRemove:null,
            draggedLamp: null,
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            picLoaded: {},
            updatingName: false,
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            dragging: false,
            drgX: '0px',
            drgY: '0px',
            dragStartEv: null,
            lampListFields: [
                {key: 'id', label: 'ID' },
                {key: 'status', label: 'Stato'}
            ],
            allLampsFields: [
                {key: 'id', label: 'ID' },
                {key: 'cu_id', label: 'Centrale'},
                {key: 'desc', label: 'Nome'}
            ],
            listDeviceFields:[
                
            ],
            currentAmbiente: {},
            selectedLamp: null,
            theme: 'bootstrap4',
            template: 'default',  
            filtroLampadeLibere: false
        }     
    
    },
    filters: {
        
        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },
        
    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),

        rndId() {
            return Math.random();
        },
        /*tabIndex() {
            if (this.currentAmbiente != null && this.currentAmbiente.isNew) return 1;
            return 0;
        },*/
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null){
                this.tableData = [];
                return null;
            } 
            if (plant.id != this.plantId) return null;
            return plant;
        },
        zoneDetails(){
            this.tableData = this.$store.state.plantZones;
            console.log("Zones: ",this.tableData);
            return this.tableData;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        },    
    },
    mounted() {
        console.log("zone mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails)
        if (this.error == null && this.plantDetails != null) {
            var dataReady = this.loadData();
            console.log("dataReady="+dataReady);
        } 
    },
    updated() {
        //console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        /*if (this.plantDetails == null && this.zoneDetails==null && this.zoneDetails==null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantZones', this.plantId)
        } */
    },
    
    watch: {
        loading(val,oldval) {
            console.log("zone loading changed:" + val+", error=" + this.error)

            if (val == false && this.error == null) {
                var dataReady = this.loadData();
                console.log("dataReady="+dataReady);
            }
            
            /*if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("devo elaborare risposta comando ", this.$store.state.commandResponse);
                
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti");
               
            }
            this.$forceUpdate();*/
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val,oldval) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);   
        },
        commandResponse(val,oldval) {
            console.log("updated commandResponse:",val);
            if (val.command == 'disclaimerPhotoAccepted'&& val.pending == false) {
                this.aggiungiPianta();       
            } 
        }
    },
    methods: {
        loadData() {
            if (this.plantDetails == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
                return false;
            } else if (this.$store.state.plantCollections==null) {
                console.log("zone, ricarico plantCollections")
                this.$store.dispatch('loadPlantCollections', this.plantId);
                return false;
            } else if (this.zoneDetails == null) {
                console.log("ricarico plant zones");
                this.$store.dispatch('loadPlantZones', this.plantId)
                return false;
            } else {
                console.log("zone dati pronti")
                //this.$forceUpdate();
            }
            return true;
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) 
            {
               return user[0].role;
            }
            return "?";
        },
        
        mostraPaginaZone() {
            this.$router.push({name: 'Zone', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaGestioneZone() {
            this.$router.push({name: 'GestioneZone', params: {pid: this.$store.state.currentPlant.id}})
        },
        paginaDettaglioZona(zone) {
            this.$store.state.currentZone = zone;
            this.$router.push({
                name: "ZoneDetail",
                params: { plantId: this.$store.state.currentPlant.id, zoneId: zone.zoneId }
            });
        },
    }
}
</script>

<style lang="scss">

.button-zone{
    height: 200px;
    width: 200px;
    background: rgb(255,255,255);
    background: linear-gradient(180deg, rgba(125,240,255,1) 0%, rgba(80,185,230,1) 100%);
    border-radius: 10px;
    border: 2px solid #8ad;
}

.close-x{
    font-size: 1.3125rem;
    font-weight: 400; 
    color: white;
    opacity:1;
}

.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}
    .nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;
        
    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 32px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;
        
    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }

    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }
    
    .highlightedAdded {
        background-color: #ffff;
    }


    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>